import { RecipeContext } from "components/recipe/providers/RecipeProvider";
import { useLocation, useNavigate } from "react-router-dom";
import BaseAccordionList from "base/BaseAccordionList";
import React, { useContext, useState } from "react";
import RecipeFilterByBadge from "components/recipe/RecipeFilterByBadge";
import RecipeSearchByIngredientIncluded from "components/recipe/RecipeSearchByIngredientIncluded";
import RecipeSearchByName from "components/recipe/RecipeSearchByName";
import RecipeSortAlphabetically from "components/recipe/RecipeSortAlphabetically";
import RecipeSortByNumOfSteps from "components/recipe/RecipeSortByNumOfSteps";

const FiltersMenu = ({ recipes, onFilterRecipes, onHandleActions }) => {
  const [expandedItem, setExpandedItem] = useState("");
  const [isShowingResultsBtn, setIsShowingResultsBtn] = useState(false);
  const { badges } = useContext(RecipeContext);
  const location = useLocation();
  const navigate = useNavigate();

  const isListView = location.pathname === "/";

  const filter = (recipes) => {
    onFilterRecipes(recipes);
  };

  const handleAction = () => {
    onHandleActions();
  };

  const handleExpandItem = (clickedItem) => {
    if (expandedItem !== clickedItem) setExpandedItem(clickedItem);
    else setExpandedItem("");
  };

  const allRecipesClicked = () => {
    onHandleActions();
    navigate("/");
  };

  return (
    <>
      {isListView ? (
        <div className="Menu-Options">
          <BaseAccordionList
            accordionFunctions={[
              {
                name: "Search",
                Search: [
                  {
                    component: (
                      <RecipeSearchByName
                        closeMenu={handleAction}
                        recipes={recipes}
                        onSearch={filter}
                      />
                    ),
                    name: "Recipe Name",
                  },
                  {
                    component: (
                      <RecipeSearchByIngredientIncluded
                        closeMenu={handleAction}
                        recipes={recipes}
                        onSearch={filter}
                      />
                    ),
                    name: "Included Ingredient",
                  },
                ],
              },
              {
                name: "Filters",
                Filter: [
                  {
                    component: (
                      <RecipeFilterByBadge
                        badges={badges}
                        recipes={recipes}
                        onFilterByBadge={filter}
                      />
                    ),
                    name: "Badge",
                  },
                ],
              },
              {
                name: "Sort",
                Sort: [
                  {
                    component: (
                      <RecipeSortAlphabetically
                        recipes={recipes}
                        onAlphaSort={filter}
                      />
                    ),
                    name: "Alphabetical",
                  },
                  {
                    component: (
                      <RecipeSortByNumOfSteps
                        recipes={recipes}
                        onNumOfStepsSort={filter}
                      />
                    ),
                    name: "Recipe Steps",
                  },
                ],
              },
            ]}
            filterByItems={badges}
            expandedItem={expandedItem}
            onExpandItem={handleExpandItem}
          />
          {isShowingResultsBtn && (
            <div className="results-btn">
              <button
                className={
                  "Green p25p2 bord-15 marg-5 Background-LGreen Box-Shadow"
                }
                onClick={handleAction}
              >
                Show Results
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="Justify-Center marg-5">
          <button
            className="Green p25p2 bord-15 Background-LGreen"
            onClick={allRecipesClicked}
          >
            All Recipes
          </button>
        </div>
      )}
    </>
  );
};

export default FiltersMenu;
